// @flow
import React, { Component } from 'react';
import { Button, Col, ControlLabel, Collapse, Alert } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';

import locale from '../../../../locales/index';
import api from '../../../../services/api';
import style from './style';

class Account extends Component<{
  user: Object,
}, {
  advanced: boolean,
}> {
  constructor(props: Object) {
    super(props);
    this.state = {
      advanced: false,
    };
  }

  toggleAdvancedMode() {
    this.setState({ advanced: !this.state.advanced });
  }

  remove() {
    api.users.delete(this.props.user.id, () => {
      window.location.reload();
    });
  }

  render() {
    return (<div>
      <span onClick={() => this.toggleAdvancedMode()} role="button">
        <h4 style={style.collapse}>
          <FontAwesome name={this.state.advanced ? 'caret-down' : 'caret-right'} /> {locale.advancedSettings}
        </h4>
      </span>

      <Collapse in={this.state.advanced}>
        <div>
          <Alert bsStyle="warning">
            <strong>{locale.dangerZoneTitle}</strong> {locale.dangerZoneContent}
          </Alert>
          <Col componentClass={ControlLabel} sm={2}>
            {locale.actions}
          </Col>
          <Col sm={10}>
            <Button onClick={() => this.remove()}>{locale.remove}</Button>
          </Col>
        </div>
      </Collapse>
    </div>);
  }
}

export default Account;



// WEBPACK FOOTER //
// ./src/scenes/UserSettings/components/Account/Account.js